import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { useRetrieveDesignElementById } from "../../hooks/useRetrieveDesignElementById";
import { SelectedElement } from "../../types/router";
import { Form } from "./components/Form";
import { QNotFound, QPageLoader } from "@qualio/ui-components";
import { testCaseToForm } from "./validation";
import { isDesignElementTestCase } from "@design-controls/types";
import { isSoureEditableAndDeletable } from "../../domain/editableSource";

export const EditTestCase: React.FC = () => {
  const navigate = useNavigate();
  const { selectedItemId } = useParams<SelectedElement>() as SelectedElement;
  const { isLoading, data } = useRetrieveDesignElementById(selectedItemId);

  const onClose = useCallback(() => navigate("../test-case"), [navigate]);

  if (isLoading) {
    return <QPageLoader />;
  }

  if (
    !data ||
    !isDesignElementTestCase(data) ||
    !isSoureEditableAndDeletable(data.source)
  ) {
    return <QNotFound data-cy="not-found" />;
  }

  return <Form testCase={testCaseToForm(data)} onClose={onClose} />;
};
